import {Component, HostListener} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'fury-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  protected readonly environment = environment;

  public isMenuOpen: boolean = false;

  @HostListener('document:keydown.escape', ['$event'])
  onEscapePressed(): void {
    this.isMenuOpen = false;
  }

  constructor() {
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
